// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skeleton_dashboardlayout {
    display: flex;
    max-width: 100%;
    height: 100vh;
}

.skeleton_dashboardlayout_content {
    overflow-y: auto;
    width: 100%;
    padding: 20px 40px;
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.skeleton_dashboardlayout_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 100%;
    padding: 5px 0;
    position: relative;
}

.skeleton_dashboardlayout_traduction_text {
    width: 60px;
    background: linear-gradient(90deg, #999595 0%, #BFBFBF 100%);
    height: 5px;
    margin: 7px 0;
    border-radius: 20px;
}

.skeleton_dashboardlayout_title {
    width: 80px;
    background: linear-gradient(90deg, #999595 0%, #BFBFBF 100%);
    height: 5px;
    border-radius: 20px;
}

.skeleton_dashboardlayout_traduction {
    background-color: #F2F3FC;
    padding: 12px 30px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    font-size: 12px;
}

.skeleton_dashboardlayout_traduction img {
    height: 8px;
    width: 8px;
}

.skeleton_dashboardlayout_traductionModal {
    position: absolute;
    right: 0;
    bottom: 0;
    transform: translateY(100%);
    background-color: #F2F3FC;
    width: 124px;
    overflow-y: hidden;
    border-radius: 10px;
    max-height: 0;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
    transition: max-height 0.3s ease-in-out;
}

.skeleton_dashboardlayout_traductionModalOpen {
    max-height: 300px;
    opacity: 1;
    padding: 10px;
}

.skeleton_dashboardlayout_traductionListe {
    display: flex;
    flex-direction: column;
    gap: 5px;
    overflow-y: auto;
    height: 100%;
}

.skeleton_dashboardlayout_traductionItem {
    margin: 0;
    cursor: pointer;
    border-radius: 8px;
    max-width: 100%;
    padding: 10px 0 10px 20px;
    font-size: 12px;
}

.skeleton_dashboardlayout_traductionItem:hover {
    background-color: #fff;
}

.skeleton_dashboardlayout_grid {
    display: grid;
    width: 100%;
    gap: 15px;
    height: 100%
}

.skeleton_dashboardlayout_grid {
    display: grid;
    grid-template-columns: repeat(10, 1fr); 
    gap: 20px;
}

.skeleton_dashboardlayout_griditem {
    height: 100%; 
    border-radius: 20px;
    border: solid 2px;
    opacity: 0.2;
    background: linear-gradient(90deg, #999595 0%, #BFBFBF 100%);
}


.skeleton_dashboardlayout_griditem_1 {
    grid-column: 1 / 5;
}

.skeleton_dashboardlayout_griditem_2 {
    grid-column: 5 / 11;
}

.skeleton_dashboardlayout_griditem_3 {
    grid-column: 1 / 6;
}

.skeleton_dashboardlayout_griditem_4 {
    grid-column: 6 / 11;
}


.lds-ripple {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
  }
  .lds-ripple div {
    position: absolute;
    border: 4px solid #000;
    opacity: 1;
    border-radius: 50%;
    animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
  }
  .lds-ripple div:nth-child(2) {
    animation-delay: -0.5s;
  }
  @keyframes lds-ripple {
    0% {
      top: 36px;
      left: 36px;
      width: 0;
      height: 0;
      opacity: 0;
    }
    4.9% {
      top: 36px;
      left: 36px;
      width: 0;
      height: 0;
      opacity: 0;
    }
    5% {
      top: 36px;
      left: 36px;
      width: 0;
      height: 0;
      opacity: 1;
    }
    100% {
      top: 0px;
      left: 0px;
      width: 72px;
      height: 72px;
      opacity: 0;
    }
  }
  

  .pageLoaderBox{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 50px 0;
  }`, "",{"version":3,"sources":["webpack://./src/components/pageLoader/pageLoader.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,4DAA4D;IAC5D,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,4DAA4D;IAC5D,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,oCAAoC;IACpC,uCAAuC;AAC3C;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,SAAS;IACT;AACJ;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,4DAA4D;AAChE;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,UAAU;IACV,kBAAkB;IAClB,8DAA8D;EAChE;EACA;IACE,sBAAsB;EACxB;EACA;IACE;MACE,SAAS;MACT,UAAU;MACV,QAAQ;MACR,SAAS;MACT,UAAU;IACZ;IACA;MACE,SAAS;MACT,UAAU;MACV,QAAQ;MACR,SAAS;MACT,UAAU;IACZ;IACA;MACE,SAAS;MACT,UAAU;MACV,QAAQ;MACR,SAAS;MACT,UAAU;IACZ;IACA;MACE,QAAQ;MACR,SAAS;MACT,WAAW;MACX,YAAY;MACZ,UAAU;IACZ;EACF;;;EAGA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;EACjB","sourcesContent":[".skeleton_dashboardlayout {\n    display: flex;\n    max-width: 100%;\n    height: 100vh;\n}\n\n.skeleton_dashboardlayout_content {\n    overflow-y: auto;\n    width: 100%;\n    padding: 20px 40px;\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n}\n\n.skeleton_dashboardlayout_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    max-width: 100%;\n    padding: 5px 0;\n    position: relative;\n}\n\n.skeleton_dashboardlayout_traduction_text {\n    width: 60px;\n    background: linear-gradient(90deg, #999595 0%, #BFBFBF 100%);\n    height: 5px;\n    margin: 7px 0;\n    border-radius: 20px;\n}\n\n.skeleton_dashboardlayout_title {\n    width: 80px;\n    background: linear-gradient(90deg, #999595 0%, #BFBFBF 100%);\n    height: 5px;\n    border-radius: 20px;\n}\n\n.skeleton_dashboardlayout_traduction {\n    background-color: #F2F3FC;\n    padding: 12px 30px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    cursor: pointer;\n    font-size: 12px;\n}\n\n.skeleton_dashboardlayout_traduction img {\n    height: 8px;\n    width: 8px;\n}\n\n.skeleton_dashboardlayout_traductionModal {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    transform: translateY(100%);\n    background-color: #F2F3FC;\n    width: 124px;\n    overflow-y: hidden;\n    border-radius: 10px;\n    max-height: 0;\n    opacity: 0;\n    transition: opacity 0.2s ease-in-out;\n    transition: max-height 0.3s ease-in-out;\n}\n\n.skeleton_dashboardlayout_traductionModalOpen {\n    max-height: 300px;\n    opacity: 1;\n    padding: 10px;\n}\n\n.skeleton_dashboardlayout_traductionListe {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    overflow-y: auto;\n    height: 100%;\n}\n\n.skeleton_dashboardlayout_traductionItem {\n    margin: 0;\n    cursor: pointer;\n    border-radius: 8px;\n    max-width: 100%;\n    padding: 10px 0 10px 20px;\n    font-size: 12px;\n}\n\n.skeleton_dashboardlayout_traductionItem:hover {\n    background-color: #fff;\n}\n\n.skeleton_dashboardlayout_grid {\n    display: grid;\n    width: 100%;\n    gap: 15px;\n    height: 100%\n}\n\n.skeleton_dashboardlayout_grid {\n    display: grid;\n    grid-template-columns: repeat(10, 1fr); \n    gap: 20px;\n}\n\n.skeleton_dashboardlayout_griditem {\n    height: 100%; \n    border-radius: 20px;\n    border: solid 2px;\n    opacity: 0.2;\n    background: linear-gradient(90deg, #999595 0%, #BFBFBF 100%);\n}\n\n\n.skeleton_dashboardlayout_griditem_1 {\n    grid-column: 1 / 5;\n}\n\n.skeleton_dashboardlayout_griditem_2 {\n    grid-column: 5 / 11;\n}\n\n.skeleton_dashboardlayout_griditem_3 {\n    grid-column: 1 / 6;\n}\n\n.skeleton_dashboardlayout_griditem_4 {\n    grid-column: 6 / 11;\n}\n\n\n.lds-ripple {\n    display: inline-block;\n    position: relative;\n    width: 80px;\n    height: 80px;\n  }\n  .lds-ripple div {\n    position: absolute;\n    border: 4px solid #000;\n    opacity: 1;\n    border-radius: 50%;\n    animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;\n  }\n  .lds-ripple div:nth-child(2) {\n    animation-delay: -0.5s;\n  }\n  @keyframes lds-ripple {\n    0% {\n      top: 36px;\n      left: 36px;\n      width: 0;\n      height: 0;\n      opacity: 0;\n    }\n    4.9% {\n      top: 36px;\n      left: 36px;\n      width: 0;\n      height: 0;\n      opacity: 0;\n    }\n    5% {\n      top: 36px;\n      left: 36px;\n      width: 0;\n      height: 0;\n      opacity: 1;\n    }\n    100% {\n      top: 0px;\n      left: 0px;\n      width: 72px;\n      height: 72px;\n      opacity: 0;\n    }\n  }\n  \n\n  .pageLoaderBox{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 50px 0;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
